import {i18n} from '@/settings';
import head from 'lodash/head';
import find from 'lodash/find';

export const getMountedLanguages = () => Object.keys(i18n?.store?.data || []);

export const getDefaultActiveLanguage = () => {
  return i18n?.store?.options?.lng || head(getMountedLanguages());
};

export const isActiveMultiLanguageByFields = (fields) => !!find(fields, {i18n: true});
